"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightCreatedEvent = exports.EVENT_INSIGHT_CREATED = void 0;
const insight_response_1 = require("../insight/insight.response");
exports.EVENT_INSIGHT_CREATED = 'insight-created';
class InsightCreatedEvent extends insight_response_1.InsightResponse {
}
exports.InsightCreatedEvent = InsightCreatedEvent;
//# sourceMappingURL=insightCreated.event.js.map